<template>
  <div id="contract" v-if="item.ContractBuyerOfRecord">
    <h3 class="h4">Contract</h3>
    <div class="form-check form-check-inline form-check-reverse">
      <input
        class="form-check-input ms-2"
        id="sendBillToContractBuyerCheckbox"
        style="border-color: #212529;"
        type="checkbox"
        :checked="item.SendBillToContractBuyer === 'T' ? true : null"
        onclick="return false;"
      />
      <label
        class="form-check-label"
        for="sendBillToContractBuyerCheckbox"
        style="color: #212529;"
      >
        Send Bill to Contract Buyer:
      </label>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4">
        <h4 class="h5">Buyer(s) of Record</h4>
        <p class="p-2 border rounded font-monospace">
          {{ item.ContractBuyerOfRecord }}
        </p>
      </div>
      <div class="col-12 col-sm-4">
        <h4 class="h5">Address</h4>
        <p
          class="p-2 border rounded font-monospace"
          v-html="FormattedContractAddress"
        />
      </div>
      <div class="col-12 col-sm-4">
        <h4 class="h5">Notes</h4>
        <p class="p-2 border rounded font-monospace">
          {{ item.ContractNotes }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    FormattedContractAddress() {
      let html = this.item.ContractAddressLine1 + "<br>";
      if (this.item.ContractAddressLine2) {
        html = html + this.item.ContractAddressLine2 + "<br>";
      }
      if (this.item.ContractCity) {
        html = html + this.item.ContractCity + ", ";
      }
      if (this.item.ContractState) {
        html = html + this.item.ContractState + "  ";
      }
      if (this.item.ContractZipCode) {
        html = html + this.item.ContractZipCode;
      }
      return html;
    },
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
